import React from "react";
import { useCart } from "../../components/Client/context/CartContext";
import { useNavigate } from "react-router-dom"; // Importar useNavigate
import "./CartPage.css";

const CartPage = () => {
  const { cartItems, addToCart, removeFromCart, clearCart } = useCart();
  const navigate = useNavigate(); // Inicializar el hook useNavigate

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const handleProceedToCheckout = () => {
    navigate("/checkout"); // Redirigir a la página de Checkout
  };

  return (
    <div className="cart-page">
      <h1 className="cart-title">Carrito de Compras</h1>
      {cartItems.length === 0 ? (
        <p className="empty-cart">Tu carrito está vacío.</p>
      ) : (
        <>
          <div className="cart-items-container">
            {cartItems.map((item) => (
              <div className="cart-item-card" key={item.id}>
                <img
                  src={item.image}
                  alt={item.name}
                  className="cart-item-image"
                />
                <div className="cart-item-details">
                  <h4 className="cart-item-name">{item.name}</h4>
                  <p>Cantidad: {item.quantity}</p>
                  <p>Precio Unitario: ${item.price.toFixed(2)}</p>
                  <p>Total: ${(item.price * item.quantity).toFixed(2)}</p>
                  <div className="cart-item-actions">
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => removeFromCart(item)}
                    >
                      -
                    </button>
                    <span className="item-quantity">{item.quantity}</span>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => addToCart(item)}
                    >
                      +
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => removeFromCart(item, true)}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="cart-summary">
            <h3>Total: ${totalPrice.toFixed(2)}</h3>
            <button className="btn btn-danger" onClick={clearCart}>
              Vaciar Carrito
            </button>
            <button
              className="btn btn-success"
              onClick={handleProceedToCheckout} // Llamar a la función para redirigir
            >
              Proceder al Pago
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
